import Vue from 'vue';
import Router from 'vue-router';
import SearchUser from '../components/SearchUser'
import TrackUser from '../components/TrackUser'


Vue.use(Router)


const routes = [
    { path : '/', redirect: '/search', meta:{title: 'Search User - MapMyActivity'}},
    { path : '/search',name:'search', component: SearchUser, meta:{title: 'Search User - MapMyActivity'}},
    { path : '/track', name:'track', component: TrackUser, props: true, meta:{title: 'Track User - MapMyActivity'}},
  ];


  
  const router = new Router({
    routes,
    mode: "history"
  });

  router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
  })

export default router